<main class="bg-primary-light" id="login-page">
    <div class="container main-panel">
        <div class="row">
            <div *ngIf="Registered" class="col-sm-12 margin-bottom-30">
                <h4>You have successfully confirmed your account. Your subscription is now active</h4>
            </div>
            <div *ngIf="ErrorMessage" class="col-sm-12 margin-bottom-30">
                <h4 class="myerror">{{ErrorMessage}}</h4>
            </div>
            <div *ngIf="!ErrorMessage && !Registered" class="col-sm-12 margin-bottom-30">
                <h4>Completing Registation. Please wait while we process your subscription...<span
                        style="margin-left: 20px" class="fa fa-spinner fa-spin"></span></h4>
            </div>
        </div>
    </div>
</main>